module.exports = __webpack_public_path__ + "img/goro-fujita-the-lantern-maker.9440fbb.jpg";